import React from "react";

const HRTag = ({ div }) => {

  const styles = {
    width: div.width || "100%",
    height: div.height || "1px",
    paddingTop: div.paddingTop || div.padding || "0",
    paddingRight: div.paddingRight || div.padding || "0",
    paddingBottom: div.paddingBottom || div.padding || "0",
    paddingLeft: div.paddingLeft || div.padding || "0",
    marginTop: div.marginTop || div.margin || "auto",
    marginRight: div.marginRight || div.margin || "auto",
    marginBottom: div.marginBottom || div.margin || "auto",
    marginLeft: div.marginLeft || div.margin || "auto",
    borderTop: div.borderTop || div.border || "none",
    borderRight: div.borderRight || div.border || "none",
    borderBottom: div.borderBottom || div.border || "0.1px solid black",
    borderLeft: div.borderLeft || div.border || "none",
    borderRadius: div.borderRadius || "0",
    boxSizing: div.boxSizing || "border-box",
    position: div.position || "relative",
    top: div.top || "auto",
    right: div.right || "auto",
    bottom: div.bottom || "auto",
    left: div.left || "auto",
    zIndex: div.zIndex || "auto",
    display: div.display || "block",
    color: div.color || "#000000",
    boxShadow: div.boxShadow || "none",
    backgroundColor: div.backgroundColor || "#ffffff",
  };

  return <hr style={styles}/>;
};

export default HRTag;
